import React, { useState } from 'react';

// navigator.clipboard needs a secure, focused context; fall back to a throwaway textarea.
const copyToClipboard = text => {
    const fallback = () => {
        const el = document.createElement('textarea');
        el.value = text;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
        return navigator.clipboard.writeText(text).catch(fallback);
    }
    fallback();
    return Promise.resolve();
};

const CopyIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </svg>
);

const CheckIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

const CopyableUrl = ({ url }) => {
    const [copied, setCopied] = useState(false);
    const copy = () =>
        copyToClipboard(url).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 1600);
        });
    return (
        <span className="mcp-url-row">
            <code className="mcp-url">{url}</code>
            <button
                type="button"
                className={copied ? 'mcp-copy-btn mcp-copy-btn--copied' : 'mcp-copy-btn'}
                onClick={copy}
                aria-label={copied ? 'Copied' : 'Copy URL'}
                title={copied ? 'Copied' : 'Copy URL'}
            >
                {copied ? <CheckIcon /> : <CopyIcon />}
            </button>
        </span>
    );
};

export default CopyableUrl;
